
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.464.5H5.536A5.535 5.535 0 000 6.034v2.932A5.535 5.535 0 005.536 14.5h2.928A5.535 5.535 0 0014 8.966V6.034A5.535 5.535 0 008.464.5zM4.235 3.35a1.384 1.384 0 11.001 2.767 1.384 1.384 0 010-2.767zm5.114 9.684a5.022 5.022 0 003.267-4.69l-.02-1.19c0-.283-.056-.816-.056-.816h-1.128a6.92 6.92 0 00-6.166 3.818 4.652 4.652 0 00-3.087-1.183h-.837a4.15 4.15 0 002.242 3.846 3.538 3.538 0 001.66.415h2.887c.421.006.84-.062 1.238-.2z","fill":"#fff"}})])
          )
        }
      }
    